import { render, staticRenderFns } from "./nature2.vue?vue&type=template&id=56385735&scoped=true&"
import script from "./nature2.vue?vue&type=script&lang=js&"
export * from "./nature2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56385735",
  null
  
)

export default component.exports